<!--
 * @Author: your name
 * @Date: 2020-08-13 11:56:23
 * @LastEditTime: 2020-11-19 14:50:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/global/FooterCommon/index.vue
-->
<style scoped lang="sass">
.footerCommon
  width: 100%
  height: 56px
  display: flex

  .submit
    width: 100%
    height: 100%
    line-height: 100%
    border: none
    font-size: 14px
    color: #fff

::v-deep
  .van-button--disabled
    background-color: rgb(221, 221, 221) !important
    opacity: 1
    font-weight: bold

</style>

<template lang="pug">
.footerCommon
  van-button.submit.ls1(type='primary' @click="$emit('clickButton')" v-bind="$attrs") {{ text }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    text: {
      type: String,
      default: 'NEXT'
    },
  },
})
class footerCommon extends Vue {
}

export default footerCommon
</script>
